<div class="container">
  <ng-template cdkPortalOutlet/>
</div>